import React from 'react'

const CustomTemplate = ({ eventId, customTemplate, urlMapper }) => {
  const { description, eventType, subject, smsBody, recipient } = customTemplate.attributes
  const sendNowUrl = urlMapper.sendNowUrl(customTemplate.id)
  const reviewListUrl = urlMapper.addToReviewListUrl(customTemplate.id)
  const showTemplateUrl = urlMapper.showTemplateUrl(customTemplate.id)
  const personalizeUrl = (eventType === "send_sms") ? urlMapper.personalizeSmsUrl(customTemplate.id) : urlMapper.personalizeEmailUrl(customTemplate.id)

  return (
    <div className="list-group-item d-flex align-items-cents">
      <div className="preview flex-grow-1">
        <div className="description">
          { description }
          { eventType == "send_email" && <span className="badge bg-primary ms-1">Email</span> }
          { eventType == "send_sms" && <span className="badge bg-primary ms-1">SMS</span> }
        </div>
        <div className="text-muted">To: { recipient }</div>
        { eventType == "send_email" && <div className="text-muted">Subject: { subject }</div> }
        { eventType == "send_sms" && <div className="text-muted">Message: { smsBody }</div> }
      </div>
      <div className="ms-3 action-buttons">
        <div className="dropdown">
          <button className="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
            <i className="fa fa-paper-plane"></i>
          </button>
          <ul className="dropdown-menu">
            <li>
              <a href={sendNowUrl} className="dropdown-item" data-method="post" data-confirm="Do you want to send this message?">Send Now</a>
            </li>
            <li>
              { !!personalizeUrl && 
                <a href={personalizeUrl} className="dropdown-item">Personalize</a>
              }
            </li>
            <li>
              <a href={reviewListUrl} className="dropdown-item" data-method="post">Add to Review List</a>
            </li>
            <li>
              <hr className="dropdown-divider" />
            </li>
            <li>
              <a href={showTemplateUrl} className="dropdown-item">Show Template</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default CustomTemplate
